import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import DomainOutlinedIcon from "@mui/icons-material/DomainOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import { hasPermission } from "./permissions";

// Menu único (Q14, spec §8.4). Seções aparecem conforme me.permissions; um item pode exigir uma permissão
// própria (`require`, ex.: o grant Campanhas) além da da seção.
export const MENU_SECTIONS = [
  {
    title: "Empresas",
    require: "companyScreens",
    items: [{ name: "Conferência de antecipações", route: "/admin/empresa/solicitacoes", icon: FactCheckOutlinedIcon }],
  },
  {
    title: "Antecipe",
    require: "backofficeRead",
    items: [
      { name: "Dashboard", route: "/admin/antecipe/dashboard", icon: InsertChartOutlinedIcon, feature: "dashboard" },
      { name: "Antecipações", route: "/admin/antecipe/solicitacoes", icon: PaymentsOutlinedIcon },
      { name: "Pacotes", route: "/admin/antecipe/pacotes", icon: Inventory2OutlinedIcon, feature: "mergeManual" },
      { name: "Dados do Médico", route: "/admin/antecipe/cadastrar-medico", icon: BadgeOutlinedIcon },
      // F4b: item com permissão própria (grant `campaigns`, Admin implica) além da flag.
      { name: "Campanhas", route: "/admin/antecipe/campanhas", icon: CampaignOutlinedIcon, require: "campaigns", feature: "campaigns" },
      // Premissas financeiras: leitura para quem vê o Financeiro; edição pela permissão Funding (Admin implica).
      { name: "Premissas financeiras", route: "/admin/antecipe/premissas-financeiras", icon: TuneOutlinedIcon, feature: "financialPremises" },
      // F3: fim da seção, fora do Dashboard (F10); só com a flag.
      { name: "Melhoria contínua", route: "/admin/antecipe/melhoria-continua", icon: AutorenewOutlinedIcon, feature: "continuousImprovement" },
    ],
  },
  {
    title: "Administração",
    require: "admin",
    items: [
      { name: "Acessos", route: "/admin/acessos", icon: ManageAccountsOutlinedIcon },
      { name: "Domínios do grupo", route: "/admin/dominios", icon: DomainOutlinedIcon },
      { name: "Empresas", route: "/admin/empresas", icon: ApartmentOutlinedIcon },
      { name: "Catálogo de motivos", route: "/admin/catalogo-motivos", icon: ListAltOutlinedIcon },
      { name: "Integrações", route: "/admin/integracoes", icon: HubOutlinedIcon, feature: "integrationsAdmin" },
      { name: "Feriados", route: "/admin/antecipe/feriados", icon: EventBusyOutlinedIcon, require: "admin", feature: "seasonality" },
    ],
  },
];

export const buildMenuSections = (me, features = {}) =>
  MENU_SECTIONS.filter((section) => hasPermission(me?.permissions, section.require))
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => (!item.feature || features[item.feature]) && hasPermission(me?.permissions, item.require)),
    }))
    .filter((section) => section.items.length > 0);
